module["exports"] = [
  "#{street_name} #{building_number}"
];



/*****************
 ** WEBPACK FOOTER
 ** ./~/faker/lib/locales/pl/address/street_address.js
 ** module id = 843
 ** module chunks = 0
 **/